import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionOpEditarConfirmarModalidadComponent {
  colaboradores
  onClose
  idOperadoraOrigen
  idProyecto
  idOperadoraDestino
  data = {
    modalidad: undefined,
    fecha_alta: undefined,
    fecha_baja: undefined,
    registrosPatronales: [],
    notas: '',
  }

  constructor (EmpleadosEmpleadoRegistrosPatronales, EmpleadosEmpleadoRegistroPatronal, EmpresaConfiguracionRegistrosPatronales, $q) {
    this.EmpleadosEmpleadoRegistrosPatronales = EmpleadosEmpleadoRegistrosPatronales
    this.EmpleadosEmpleadoRegistroPatronal = EmpleadosEmpleadoRegistroPatronal
    this.EmpresaConfiguracionRegistrosPatronales = EmpresaConfiguracionRegistrosPatronales
    this.$q = $q
  }

  $onInit () {
    this.promise = this.$q.all([
      this.EmpleadosEmpleadoRegistrosPatronales.get(this.idProyecto)
        .then(({data}) => (this.registrosEnProyecto = data)),
      this.EmpleadosEmpleadoRegistroPatronal.get(this.idProyecto)
        .then(({data}) => (this.registrosOperadoraOrigen = data)),
      this.EmpresaConfiguracionRegistrosPatronales.get(null, this.idOperadoraDestino)
        .then(({data}) => (this.registrosOperadoraDestino = data)),
    ])
      .catch((error) => (console.log(error)))

  }

  procesar(data) {
    let encontro = this.data.registrosPatronales.find(i => data.registroPatronalIdOrigen === i.registroPatronalIdOrigen)
    if(encontro) {
      encontro.registroPatronalIdDestino = data.registroPatronalIdDestino
    }else {
      this.data.registrosPatronales.push(data)
    }
  }

  aceptar () {
    this.onClose({
      $event: {
        data: this.data,
      },
    })
  }

  cancelar () {
    this.onClose()
  }
}

module.component('fanProyectoConfigOpEditarConfirmarModalidad', {
  controller: FanProyectoConfiguracionOpEditarConfirmarModalidadComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idOperadoraOrigen: '<',
    idOperadoraDestino: '<',
    colaboradores: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/op/editar/confirmar/modalidad/component.js